import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import CarouselHOC from '../CarouselHOC';
// import {Box, Button, Typography, Container, Grid} from "@mui/material";

// To override/merge styles in CarouselHOC:
const useStyles = makeStyles((theme) => createStyles({
  rootCarousel: {

    '& .slick-slider': {
      position: 'initial'
    },
    '& .featured .slick-slide': {
      [theme.breakpoints.up('md')]: {
        '& > div': {
          height: 135
        }
      },
      [theme.breakpoints.up('md')]: {
        '& > div': {
          height: 280,
          overflow: 'hidden !important',
        }
      }
    },

    '& .slick-slide > div:first-child > div': {
      // paddingBottom: '10px',
      borderTop: 'none',
    },
    '& .slick-slide > div:last-child > div': {
      borderTop: 'solid 10px white !important',
      borderBottom: 'none !important',
      overflow: 'hidden !important',
      backgroundColor: 'white',
    },
    '& .slick-slide > div:only-child > div': {
      borderTop: 'solid 10px white !important',
      borderBottom: 'none !important',
      borderRight: 'none !important',
    },
    '& .slick-slide': {
      '& > div': {
        height: 'auto'
      },
      '& >div>*:not(:last-child)': {
        [theme.breakpoints.up('md')]: {
          paddingRight: 0
        }
      },
      '& >div>div>*': {
        overflow: 'visible !important',
        display: 'inline',
        [theme.breakpoints.down('lg')]: {
          width: '100% !important',
        }
      }
    },
    '& .slick-dots': {
      position: 'absolute',
      bottom: '1.5rem',
      left: '1.5rem',
      textAlign: 'left',
      '& li button:before': {
        fontSize: 24,
        color: 'white',
        opacity: 1
      },
      '& li.slick-active button:before': {
        color: theme.palette.warning.main
      },
      '& li:hover button:before': {
        color: theme.palette.warning.main
      }
    }
  },
  slickPrev: {},
  slickSliderInner: {
    '&.featured': {
      [theme.breakpoints.up('md')]: {
        width: '200%',
        marginLeft: '-100%',
        clear: 'both',
        transition: 'all .5s',

        '& $firstImage': {
          width: '50%',
          transition: 'all .5s'
        },
        '& $slickImages': {
          width: '50%',
          display: 'inline-block',
          transition: 'all .5s'
        },
        '& $galleryImage': {
          height: 135,
          [theme.breakpoints.up('md')]: {
            height: 280,
            borderBottom: 'none',
            overflowX: 'hidden',
          }
        }
      }
    },
    '&.featured.active': {
      [theme.breakpoints.up('md')]: {
        marginLeft: '-33%',
        '& $galleryImage': {
          paddingLeft: '0px',
          paddingRight: '0px',
          borderRight: 'none',
        },
        '& :not(.thumb-nav)>$slickNext': {
          right: '0'
        },
        '& :not(.thumb-nav)>$slickPrev': {
          left: '0'
        },
      },
    },
    '&.featured:not(.active) > div > div > span': {
      display: 'none !important',
    },
    '& .slick-current div div': {
      borderLeft: 'none !important',
    },
    '& .slick-current + .slick-slide + .slick-slide div div': {
      borderRight: 'none !important',
    },
  },
  firstImage: {
    display: 'inline-block'
  },
  slickImages: {},
  featuredImage: {
    height: '270px !important',
    [theme.breakpoints.up('md')]: {
      height: '560px !important',
      borderRight: 'solid 20px white',
    },
  },
  galleryImage: {
    height: 'auto',
    [theme.breakpoints.up('md')]: {
      height: 560,
      border: 'solid 10px white',
      borderRight: 'none',
    }
  },
  thumbImage: {
    height: 'auto',
  },
  slickArrow: {
    backgroundColor: 'rgba(0,0,0,.8)',
    width: '30px',
    '& svg': {
      width: '2rem',
      height: '3rem',
      fill: 'white !important'
    }
  },
  slickNext: {
    right: '0'
  }
}));

function CarouselMuiSlider(props) {
  let {
    customClass,
    slides,
    showLight,
    showThumb,
    featured,
    slickSett,
    slickNavSett,
    children,
    margin,
    marginUnit,
    linkOut,
    gutter,
    captions,
    fetchSlidesOpt
  } = props;

  if (!fetchSlidesOpt && !props.slides && !props.children) {
    return null;
  }

  showThumb = showThumb || {
    mdUp: true
  };
  customClass = customClass || '';
  const HOCstyles = useStyles();

  return (
    <div className={customClass}>
      <CarouselHOC classes={HOCstyles} slides={slides} featured={featured}
                   slickSett={slickSett} showLight={showLight} showThumb={showThumb}
                   margin={margin} marginUnit={marginUnit} linkOut={linkOut}
                   gutter={gutter} slickNavSett={slickNavSett} captions={captions}
                   fetchSlidesOpt={fetchSlidesOpt}
      >
        {children}
      </CarouselHOC>
    </div>
  );
}

export default CarouselMuiSlider;
